import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuTitle: {
		id: 'jira.issue-navigator.filters-menu.menu-title',
		defaultMessage: 'Saved filters',
		description: 'Title for the saved filters menu in the project issue navigator.',
	},
	filtersMenuLabel: {
		id: 'issue-navigator-filters-menu.FiltersMenuContent.messages.updated-recently.filters-menu-label',
		defaultMessage: 'Saved filters menu',
		description: 'Accessible label for the saved filters menu in list view',
	},
});
